// Arabic Language Support Implementation Plan

// 1. Create translations file
// src/translations/ar.js
const arabicTranslations = {
    // Common elements
    app: {
      title: 'لوحة تحكم برنامج الولاء',
      version: 'الإصدار 1.0.0',
    },
    
    // Navigation
    nav: {
      dashboard: 'لوحة المعلومات',
      customers: 'العملاء',
      transactions: 'المعاملات',
      rewards: 'المكافآت',
      settings: 'الإعدادات',
    },
    
    // Dashboard page
    dashboard: {
      title: 'نظرة عامة',
      subtitle: 'مرحبًا بك في لوحة تحكم برنامج الولاء',
      stats: {
        totalCustomers: 'إجمالي العملاء',
        totalPoints: 'إجمالي النقاط',
        transactions: 'المعاملات',
        averagePoints: 'متوسط النقاط',
      },
      charts: {
        monthlyPoints: 'إصدار النقاط الشهرية',
      },
      recentCustomers: 'العملاء الأخيرين',
      empty: 'لا توجد بيانات عملاء متاحة',
    },
    
    // Customer management page
    customers: {
      title: 'إدارة العملاء',
      subtitle: 'البحث عن العملاء وإضافتهم وإدارتهم',
      search: {
        placeholder: 'أدخل رقم هاتف العميل',
        button: 'بحث',
        searching: 'جاري البحث...',
      },
      newCustomer: {
        title: 'تسجيل عميل جديد',
        nameLabel: 'اسم العميل',
        cityLabel: 'المدينة',
        amountLabel: 'مبلغ الشراء الأولي (بالدولار)',
        button: 'تسجيل العميل',
        processing: 'جاري التسجيل...',
      },
      customerDetails: {
        title: 'معلومات العميل',
        points: 'النقاط',
        eligible: 'مؤهل للاسترداد!',
        newPurchase: {
          title: 'تسجيل عملية شراء جديدة',
          placeholder: 'مبلغ الشراء بالدولار',
          button: 'إضافة عملية شراء',
          processing: 'جاري الإضافة...',
        },
        transactions: {
          title: 'سجل المعاملات',
          date: 'التاريخ',
          amount: 'المبلغ',
          points: 'النقاط',
          status: 'الحالة',
          empty: 'لا يوجد سجل معاملات متاح',
        },
      },
      directory: {
        title: 'دليل العملاء',
        tabs: {
          all: 'جميع العملاء',
          eligible: 'مؤهلين للاسترداد',
          top: 'أفضل 5 عملاء',
        },
        summary: {
          total: 'إجمالي العملاء',
          eligible: 'مؤهلين للمكافآت',
          top: 'أفضل العملاء',
        },
        empty: 'لم يتم العثور على عملاء',
        refresh: 'تحديث',
      },
      points: 'نقاط',
      eligible: 'مؤهل',
    },
    
    // Transactions page
    transactions: {
      title: 'المعاملات',
      subtitle: 'عرض وتحليل جميع معاملات العملاء',
      stats: {
        totalTransactions: 'إجمالي المعاملات',
        totalRevenue: 'إجمالي الإيرادات',
        totalPoints: 'إجمالي النقاط الصادرة',
        averageOrder: 'متوسط قيمة الطلب',
      },
      filter: {
        title: 'تصفية المعاملات',
        dateRange: {
          label: 'النطاق الزمني',
          options: {
            all: 'كل الوقت',
            today: 'اليوم',
            yesterday: 'الأمس',
            week: 'آخر 7 أيام',
            month: 'آخر 30 يوم',
            custom: 'نطاق مخصص',
          },
          start: 'تاريخ البداية',
          end: 'تاريخ النهاية',
        },
        amount: {
          min: 'الحد الأدنى للمبلغ ($)',
          max: 'الحد الأقصى للمبلغ ($)',
        },
        customer: {
          label: 'البحث عن العميل',
          placeholder: 'الاسم أو الهاتف',
        },
        sort: {
          label: 'ترتيب حسب',
          options: {
            dateDesc: 'التاريخ (الأحدث أولاً)',
            dateAsc: 'التاريخ (الأقدم أولاً)',
            amountDesc: 'المبلغ (من الأعلى إلى الأقل)',
            amountAsc: 'المبلغ (من الأقل إلى الأعلى)',
            pointsDesc: 'النقاط (من الأعلى إلى الأقل)',
            pointsAsc: 'النقاط (من الأقل إلى الأعلى)',
          },
        },
        buttons: {
          apply: 'تطبيق التصفية',
          reset: 'إعادة تعيين',
        },
      },
      analytics: {
        topDays: 'أفضل أيام الأداء',
      },
      table: {
        date: 'التاريخ',
        customer: 'العميل',
        amount: 'المبلغ',
        points: 'النقاط',
        status: 'الحالة',
        actions: 'الإجراءات',
      },
    },
    
    // Rewards management page
    rewards: {
      title: 'إدارة المكافآت',
      subtitle: 'تكوين وإدارة مكافآت العملاء',
      tabs: {
        tiers: 'مستويات المكافآت',
        promotions: 'العروض الترويجية',
        redemptions: 'سجل الاسترداد',
        settings: 'الإعدادات',
      },
      tiers: {
        current: 'مستويات المكافآت الحالية',
        create: 'إنشاء مستوى مكافآت جديد',
        form: {
          name: 'اسم المستوى',
          pointsRequired: 'النقاط المطلوبة',
          description: 'الوصف',
          active: 'نشط',
          placeholder: {
            name: 'مثل: برونزي، فضي، ذهبي',
            description: 'وصف المكافآت المتاحة في هذا المستوى',
            points: 'الحد الأدنى من النقاط المطلوبة',
          },
          buttons: {
            create: 'إنشاء مستوى مكافآت',
            update: 'حفظ التغييرات',
            cancel: 'إلغاء',
            edit: 'تعديل',
            delete: 'حذف',
          },
        },
        empty: 'لم يتم إنشاء مستويات مكافآت بعد. قم بإنشاء أول مستوى مكافآت للبدء.',
        points: 'نقاط',
      },
      promotions: {
        current: 'العروض الترويجية الحالية',
        create: 'إنشاء عرض ترويجي جديد',
        form: {
          name: 'اسم العرض الترويجي',
          multiplier: 'مضاعف النقاط',
          startDate: 'تاريخ البدء',
          endDate: 'تاريخ الانتهاء',
          description: 'الوصف',
          active: 'نشط',
          placeholder: {
            name: 'مثل: عطلة نهاية الأسبوع بنقاط مضاعفة',
            multiplier: 'مثل: 2 لنقاط مضاعفة',
            description: 'وصف العرض الترويجي وأي شروط خاصة',
          },
          buttons: {
            create: 'إنشاء عرض ترويجي',
            update: 'حفظ التغييرات',
            cancel: 'إلغاء',
            edit: 'تعديل',
            delete: 'حذف',
          },
        },
        empty: 'لم يتم إنشاء عروض ترويجية بعد. قم بإنشاء أول عرض ترويجي لتقديم فرص نقاط خاصة.',
        dates: {
          from: 'من',
          to: 'إلى',
        },
        multiplier: 'مضاعف النقاط',
      },
      redemptions: {
        stats: {
          total: 'إجمالي عمليات الاسترداد',
          points: 'النقاط المستردة',
          average: 'متوسط الاسترداد',
        },
        history: 'سجل الاسترداد',
        table: {
          date: 'التاريخ',
          customer: 'العميل',
          points: 'النقاط المستردة',
          reward: 'المكافأة',
          status: 'الحالة',
        },
        empty: 'لا يوجد سجل استرداد متاح. سيتم تعبئة هذا القسم عندما يقوم العملاء باسترداد نقاطهم.',
        status: {
          completed: 'مكتمل',
          pending: 'قيد الانتظار',
          cancelled: 'ملغي',
          processing: 'قيد المعالجة',
        },
      },
      settings: {
        title: 'إعدادات المكافآت العامة',
        pointsPerDollar: {
          label: 'النقاط لكل دولار منفق',
          hint: 'هذا هو المعدل الأساسي لحساب النقاط. يمكن للعروض الترويجية تعديل هذا المعدل مؤقتًا.',
        },
        expiration: {
          label: 'انتهاء صلاحية النقاط (بالأشهر)',
          hint: 'اضبطه على 0 لعدم انتهاء الصلاحية. وإلا، ستنتهي صلاحية النقاط بعد هذا العدد من الأشهر.',
        },
        minRedemption: {
          label: 'الحد الأدنى من النقاط للاسترداد',
          hint: 'يجب أن يكون لدى العملاء على الأقل هذا العدد من النقاط لاسترداد المكافآت.',
        },
        save: 'حفظ الإعدادات',
      },
    },
    
    // Settings page
    settings: {
      title: 'الإعدادات',
      subtitle: 'تكوين إعدادات برنامج الولاء',
      tabs: {
        general: 'عام',
        notifications: 'الإشعارات',
        points: 'النقاط والمكافآت',
        staff: 'إدارة الموظفين',
        data: 'إدارة البيانات',
      },
      general: {
        businessInfo: {
          title: 'معلومات العمل',
          subtitle: 'تحديث تفاصيل وعلامة عملك التجارية',
        },
        businessName: 'اسم العمل',
        businessPhone: 'هاتف العمل',
        businessEmail: 'بريد العمل الإلكتروني',
        businessAddress: 'عنوان العمل',
        branding: {
          title: 'العلامة التجارية',
        },
        logoUrl: {
          label: 'رابط الشعار',
          placeholder: 'https://example.com/logo.png',
          hint: 'أدخل رابطًا مباشرًا لصورة الشعار الخاص بك',
        },
        colors: {
          primary: 'اللون الأساسي',
          accent: 'لون التمييز',
          preview: 'معاينة الألوان:',
        },
        save: 'حفظ الإعدادات العامة',
      },
      notifications: {
        title: 'إعدادات الإشعارات',
        subtitle: 'تكوين كيفية ومتى يتلقى العملاء الإشعارات',
        enableSms: {
          label: 'تمكين إشعارات الرسائل القصيرة',
          hint: 'عند التمكين، سيتلقى العملاء رسائل نصية قصيرة لتحديثات النقاط والمكافآت',
        },
        templates: {
          welcome: {
            title: 'رسالة الترحيب',
          },
          pointsUpdate: {
            title: 'تحديث النقاط',
          },
          rewardEligible: {
            title: 'مؤهل للمكافآت',
          },
          variables: {
            heading: 'المتغيرات المتاحة:',
            customerName: '{customerName}',
            points: '{points}',
            totalPoints: '{totalPoints}',
            businessName: '{businessName}',
            rewardName: '{rewardName}',
          },
        },
        save: 'حفظ إعدادات الإشعارات',
      },
      points: {
        title: 'تكوين النقاط والمكافآت',
        subtitle: 'تكوين كيفية اكتساب النقاط واستردادها',
        pointsPerDollar: {
          label: 'النقاط لكل دولار منفق',
          hint: 'عدد النقاط المكتسبة لكل دولار منفق',
        },
        minPointsForRedemption: {
          label: 'الحد الأدنى من النقاط للاسترداد',
          hint: 'الحد الأدنى من النقاط المطلوبة قبل أن يتمكن العملاء من استرداد المكافآت',
        },
        pointsExpiration: {
          label: 'انتهاء صلاحية النقاط (بالأشهر)',
          hint: 'اضبطه على 0 لعدم انتهاء الصلاحية. وإلا، ستنتهي صلاحية النقاط بعد هذا العدد من الأشهر.',
        },
        roundingMethod: {
          label: 'طريقة تقريب النقاط',
          options: {
            up: 'تقريب دائمًا للأعلى',
            down: 'تقريب دائمًا للأسفل',
            nearest: 'تقريب إلى الأقرب',
          },
          hint: 'كيفية التعامل مع النقاط الكسرية',
        },
        allowPartial: {
          label: 'السماح بالاسترداد الجزئي',
          hint: 'السماح للعملاء باسترداد جزء من نقاطهم بدلاً من كلها دفعة واحدة',
        },
        activePromotions: {
          label: 'تمكين العروض الترويجية النشطة',
          hint: 'تطبيق العروض الترويجية النشطة على حسابات النقاط',
        },
        save: 'حفظ إعدادات النقاط',
      },
      staff: {
        title: 'أعضاء الفريق',
        subtitle: 'إدارة الوصول إلى لوحة تحكم الولاء',
        invite: {
          title: 'دعوة عضو فريق',
          email: {
            label: 'عنوان البريد الإلكتروني',
            placeholder: 'staff@example.com',
          },
          role: {
            label: 'الدور',
            options: {
              admin: 'مدير (وصول كامل)',
              staff: 'موظف (وصول محدود)',
              viewer: 'مشاهد (للقراءة فقط)',
            },
            description: {
              admin: 'وصول كامل إلى جميع الميزات',
              staff: 'يمكنه إدارة العملاء والمعاملات',
              viewer: 'يمكنه عرض البيانات ولكن لا يمكنه إجراء تغييرات',
            },
          },
          sendInvite: 'إرسال دعوة بالبريد الإلكتروني',
          button: 'دعوة عضو فريق',
        },
        table: {
          email: 'البريد الإلكتروني',
          role: 'الدور',
          status: 'الحالة',
          actions: 'الإجراءات',
        },
        status: {
          active: 'نشط',
          pending: 'قيد الانتظار',
          inactive: 'غير نشط',
        },
        confirmRemove: 'هل أنت متأكد أنك تريد إزالة هذا العضو من الفريق؟',
        empty: 'لم تتم إضافة أعضاء فريق بعد. قم بدعوة أعضاء الفريق للمساعدة في إدارة برنامج الولاء الخاص بك.',
      },
      data: {
        title: 'إدارة البيانات',
        subtitle: 'تكوين النسخ الاحتياطي واستعادة البيانات والاحتفاظ بها',
        automaticBackup: {
          label: 'تمكين النسخ الاحتياطي التلقائي',
          hint: 'نسخ بيانات برنامج الولاء الخاص بك احتياطيًا تلقائيًا',
        },
        backupFrequency: {
          label: 'تكرار النسخ الاحتياطي',
          options: {
            daily: 'يوميًا',
            weekly: 'أسبوعيًا',
            monthly: 'شهريًا',
          },
          hint: 'عدد مرات إنشاء نسخ احتياطية تلقائية',
        },
        dataRetention: {
          label: 'الاحتفاظ بالبيانات (بالأيام)',
          hint: 'عدد الأيام للاحتفاظ ببيانات النسخ الاحتياطي',
        },
        manualData: {
          title: 'إدارة البيانات اليدوية',
        },
        export: {
          title: 'تصدير البيانات',
          description: 'تصدير جميع بيانات برنامج الولاء الخاص بك كملف CSV أو JSON',
          button: 'تصدير البيانات',
        },
        import: {
          title: 'استيراد البيانات',
          description: 'استيراد بيانات العملاء والمعاملات من ملف',
          button: 'استيراد البيانات',
        },
        clear: {
          title: 'مسح البيانات',
          description: 'إزالة جميع البيانات من برنامج الولاء الخاص بك',
          button: 'مسح البيانات',
        },
        save: 'حفظ إعدادات البيانات',
      },
    },
    
    // Common UI components
    common: {
      loading: 'جاري التحميل...',
      saving: 'جاري الحفظ...',
      creating: 'جاري الإنشاء...',
      updating: 'جاري التحديث...',
      processing: 'جاري المعالجة...',
      sending: 'جاري الإرسال...',
      confirmDelete: 'هل أنت متأكد أنك تريد الحذف؟',
      noDataAvailable: 'لا توجد بيانات متاحة',
      requiredFields: 'جميع الحقول مطلوبة',
      pagination: {
        previous: 'السابق',
        next: 'التالي',
      },
      status: {
        active: 'نشط',
        inactive: 'غير نشط',
        pending: 'قيد الانتظار',
        completed: 'مكتمل',
        processing: 'قيد المعالجة',
        cancelled: 'ملغي',
      },
    },
    
    // Notifications and alerts
    notifications: {
      success: {
        customerRegistered: 'تم تسجيل العميل {name}! حصل على {points} نقطة على عملية الشراء الأولى.',
        transactionRecorded: 'تم تسجيل المعاملة! حصل العميل على {points} نقطة.',
        settingsSaved: 'تم حفظ الإعدادات بنجاح',
        tierUpdated: 'تم تحديث مستوى المكافآت بنجاح',
        tierCreated: 'تم إنشاء مستوى مكافآت جديد بنجاح',
        tierDeleted: 'تم حذف مستوى المكافآت بنجاح',
        promoUpdated: 'تم تحديث العرض الترويجي بنجاح',
        promoCreated: 'تم إنشاء عرض ترويجي جديد بنجاح',
        promoDeleted: 'تم حذف العرض الترويجي بنجاح',
        staffInvited: 'تمت دعوة عضو الفريق بنجاح',
        staffUpdated: 'تم تحديث دور عضو الفريق',
        staffRemoved: 'تمت إزالة عضو الفريق بنجاح',
      },
      error: {
        customerSearch: 'خطأ في البحث عن العميل: {message}',
        registration: 'خطأ في تسجيل العميل: {message}',
        addPurchase: 'خطأ في إضافة عملية شراء: {message}',
        loadSettings: 'فشل في تحميل الإعدادات. يرجى المحاولة مرة أخرى.',
        saveSettings: 'فشل في حفظ الإعدادات. يرجى المحاولة مرة أخرى.',
        loadCustomers: 'فشل في تحميل العملاء: {message}',
        loadTransactions: 'فشل في تحميل المعاملات: {message}',
        loadRewards: 'فشل في تحميل بيانات المكافآت. يرجى المحاولة مرة أخرى.',
        updateTier: 'فشل في تحديث مستوى المكافآت. يرجى المحاولة مرة أخرى.',
        createTier: 'فشل في إنشاء مستوى المكافآت. يرجى المحاولة مرة أخرى.',
        deleteTier: 'فشل في حذف مستوى المكافآت. يرجى المحاولة مرة أخرى.',
        updatePromo: 'فشل في تحديث العرض الترويجي. يرجى المحاولة مرة أخرى.',
        createPromo: 'فشل في إنشاء العرض الترويجي. يرجى المحاولة مرة أخرى.',
        deletePromo: 'فشل في حذف العرض الترويجي. يرجى المحاولة مرة أخرى.',
        staffInvite: 'فشل في دعوة عضو الفريق. يرجى المحاولة مرة أخرى.',
        staffUpdate: 'فشل في تحديث دور عضو الفريق. يرجى المحاولة مرة أخرى.',
        staffRemove: 'فشل في إزالة عضو الفريق. يرجى المحاولة مرة أخرى.',
        loadStaff: 'فشل في تحميل أعضاء الفريق. يرجى المحاولة مرة أخرى.',
      },
      validation: {
        phoneRequired: 'يرجى إدخال رقم هاتف',
        allFieldsRequired: 'جميع الحقول مطلوبة',
        amountRequired: 'يرجى إدخال مبلغ الشراء',
        nameRequired: 'اسم المستوى مطلوب',
        pointsRequired: 'النقاط المطلوبة مطلوبة',
        promoNameRequired: 'اسم العرض الترويجي مطلوب',
        datesRequired: 'تاريخ البدء وتاريخ الانتهاء مطلوبان',
        emailRequired: 'عنوان البريد الإلكتروني مطلوب',
      },
    },
  };
  
  export default arabicTranslations;